interface LeftSidebarSettings {
  show?: boolean;
  mode: "full" | "close" | "compact" | "mobile";
  theme?: string;
  bgImgURL?: string;
  [otherOptions: string]: unknown;
}

interface TopbarSettings {
  show?: boolean;
  fixed: boolean;
  theme?: string;
  [otherOptions: string]: unknown;
}

export interface SleekLayoutSettingsType {
  leftSidebar?: LeftSidebarSettings;
  topbar?: TopbarSettings;
}

const SleekLayoutSettings: SleekLayoutSettingsType = {
  leftSidebar: {
    show: true,
    mode: "full",
    theme: "slateDark1",
    bgImgURL: undefined,
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "whiteBlue",
  },
};

export default SleekLayoutSettings;